function parseBZFooterJson(value, fallback) {
  if (typeof value !== 'string' || !value.trim() || value.trim() === '-') return fallback;

  try {
    return JSON.parse(value);
  } catch (error) {
    return fallback;
  }
}

function normalizeBZFooterUrl(value) {
  if (typeof value !== 'string') return '';

  const normalized = value.trim();
  return normalized === '-' || normalized === '—' ? '' : normalized;
}

if (!customElements.get('bz-site-footer')) {
  customElements.define(
    'bz-site-footer',
    class BZSiteFooter extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';

        const locations = parseBZFooterJson(this.dataset.bzLocations, []);

        const showLocationsButton = Array.isArray(locations) && locations.length > 1;
        this.querySelectorAll('[data-bz-locations-button]').forEach((button) => {
          button.hidden = !showLocationsButton;
        });

        const socials = parseBZFooterJson(this.dataset.bzSocials, {});
        let hasSocials = false;

        this.querySelectorAll('[data-bz-social-link]').forEach((link) => {
          const platform = link.dataset.platform || '';
          const cmsUrl = socials && typeof socials === 'object'
            ? normalizeBZFooterUrl(socials[platform])
            : '';
          const socialUrl = cmsUrl || normalizeBZFooterUrl(link.dataset.fallbackUrl);

          link.hidden = !socialUrl;
          if (socialUrl) {
            link.setAttribute('href', socialUrl);
            hasSocials = true;
          } else {
            link.removeAttribute('href');
          }
        });

        const socialsNav = this.querySelector('[data-bz-socials-nav]');
        if (socialsNav) socialsNav.hidden = !hasSocials;

        this.querySelectorAll('[data-bz-cookie-preferences]').forEach((link) => {
          link.addEventListener('click', (event) => {
            if (window.OneTrust?.ToggleInfoDisplay) {
              event.preventDefault();
              window.OneTrust.ToggleInfoDisplay();
              return;
            }

            if (link.getAttribute('href') === '#') event.preventDefault();
          });
        });
      }
    }
  );
}
